import { monolithHttpClient } from 'src/editor/api/http-clients/monolith-http-client'
import { pageEditorHttpClient } from 'src/editor/api/http-clients/page-editor-http-client'

export const fetchPageData = (pageId, isTemplate) =>
  monolithHttpClient.get(
    isTemplate ? `/page-template/${pageId}/edit` : `/page/${pageId}/edit`,
    {
      withCredentials: true,
    },
  )

export const fetchEditorPage = (pageId, layoutId) =>
  pageEditorHttpClient(`page/${layoutId}/${pageId}/edit`)

export const previewPage = (
  { id, entities, seo, tracking, locale, globalSettings },
  isTemplate,
) =>
  monolithHttpClient.post(
    isTemplate ? `/page-template/${id}/preview` : `/page/${id}/preview/v2`,
    isTemplate
      ? {
          editor_api_page_content: {
            content: JSON.stringify({
              entities,
              seo,
              tracking,
              globalSettings,
            }),
            locale,
          },
        }
      : {
          content: JSON.stringify({
            entities,
            seo,
            tracking,
            globalSettings,
          }),
          locale,
        },
  )

export const savePage = (page, isTemplate) => {
  const savePath = isTemplate
    ? `/page-template/${page.id}/save`
    : `/page/${page.id}/save/v2`

  const contentPayload = {
    entities: page.entities,
    lastPopupNumber: page.lastPopupNumber,
    id: page.id,
    seo: page.seo,
    tracking: page.tracking,
    globalColor: page.globalColor,
    doubleOptIn: page.doubleOptIn,
    globalSettings: page.globalSettings,
  }

  const body = isTemplate
    ? {
        editor_api_page_content: {
          content: JSON.stringify(contentPayload),
          locale: page.locale,
        },
      }
    : {
        content: JSON.stringify(contentPayload),
        locale: page.locale,
      }

  return monolithHttpClient.post(savePath, {
    ...body,
  })
}

export const fetchPageAutomationRulesData = pageId => {
  return monolithHttpClient.get(
    `/automation-rules-with-button-id-by-page-id/${pageId}`,
  )
}

export const savePageAutomationRulesData = (pageId, payload) => {
  return monolithHttpClient.post(
    `/update-automation-rules-with-page/${pageId}`,
    payload,
  )
}

export const fetchUserColors = () => {
  return monolithHttpClient.get(`/user/colors`)
}
